// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-menu-item,.el-submenu__title{font-size:1.1rem!important}", ""]);
// Exports
module.exports = exports;
